import React, { FC } from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';

import { palette } from '../../theme';
import './add-session-choice.dialog.css';

export interface AddSessionChoiceDialogProps {
  open: boolean;
  dayLabel: string;
  onClose: () => void;
  onNewTraining: () => void;
  onTrainingLibrary: () => void;
}

const AddSessionChoiceDialog: FC<AddSessionChoiceDialogProps> = ({
  open,
  dayLabel,
  onClose,
  onNewTraining,
  onTrainingLibrary,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: 'add-session-choice-paper' }}
    >
      <IconButton className="add-session-choice-close" onClick={onClose} aria-label="Close" size="small">
        <CloseIcon fontSize="small" />
      </IconButton>

      <Typography className="add-session-choice-title">Add Session — {dayLabel}</Typography>

      <Box className="add-session-choice-grid">
        <button type="button" className="add-session-choice-card" onClick={onNewTraining}>
          <Box className="add-session-choice-icon" style={{ background: palette.primary.light }}>
            <AddIcon sx={{ fontSize: 28, color: palette.primary.main }} />
          </Box>
          <Typography className="add-session-choice-label">New Training</Typography>
          <Typography className="add-session-choice-desc">Create a session from scratch</Typography>
        </button>

        <button type="button" className="add-session-choice-card" onClick={onTrainingLibrary}>
          <Box className="add-session-choice-icon" style={{ background: '#FEF3C7' }}>
            <MenuBookOutlinedIcon sx={{ fontSize: 26, color: '#D97706' }} />
          </Box>
          <Typography className="add-session-choice-label">Training Library</Typography>
          <Typography className="add-session-choice-desc">Pick from saved sessions</Typography>
        </button>
      </Box>
    </Dialog>
  );
};

export default AddSessionChoiceDialog;
